import { Component, ElementRef, Input, Renderer2 } from '@angular/core';

declare var Circles;

@Component({
    moduleId: module.id,
    selector: 'chart-pie',
    templateUrl: 'pie-chart.component.html',
})
export class ChartPieComponent {
    @Input() eventsDone: number;
    @Input() eventsTodo: number;
    @Input() radius: number = 50;
    @Input() color: string;
    @Input() id: string;


    constructor(private _el: ElementRef, renderer: Renderer2) {
    }

    ngOnInit() {
        this.bindChart();
        // let todoCount = this.eventsTodo;
        // Circles.create({
        //     id: this.id,
        //     radius: 43,
        //     value: +this.eventsDone,
        //     maxValue: +(this.eventsTodo + this.eventsDone),
        //     width: 3,
        //     text: function (value) { return todoCount; },
        //     colors: [this.color, '#dedede'],
        //     duration: 1000,
        //     wrpClass: 'circles-wrp',
        //     textClass: 'circles-text',
        //     valueStrokeClass: 'circles-valueStroke',
        //     maxValueStrokeClass: 'circles-maxValueStroke',
        //     styleWrapper: true,
        //     styleText: true
        // });
        // 
        // 
        // 
        // 
    }

    ngAfterViewInit() {
        this.bindChart();
        // 
        // 
        // 
        // 
    }

    ngOnChanges(){
        this.bindChart();
    }

    public bindChart() {
        let todoCount = this.eventsTodo;
        Circles.create({
            id: this.id,
            radius: this.radius,
            value: this.eventsDone,
            maxValue: this.eventsTodo + this.eventsDone,
            width: 3,
            text: function (value) { return todoCount; },
            colors: [this.color, '#dedede'],
            duration: 1000,
            wrpClass: 'circles-wrp',
            textClass: 'circles-text',
            valueStrokeClass: 'circles-valueStroke',
            maxValueStrokeClass: 'circles-maxValueStroke',
            styleWrapper: true,
            styleText: true
        });
    }
}